import { useEffect, useRef } from 'react';

const EDGE_WIDTH = 24;
const SWIPE_THRESHOLD = 80;
const ANGLE_LIMIT = 30;

export default function useSwipeBack({ canGoBack, goBack }) {
  const touchRef = useRef(null);

  useEffect(() => {
    function onTouchStart(e) {
      const touch = e.touches[0];
      if (touch.clientX <= EDGE_WIDTH) {
        touchRef.current = { x: touch.clientX, y: touch.clientY };
      }
    }

    function onTouchEnd(e) {
      if (!touchRef.current || !canGoBack) {
        touchRef.current = null;
        return;
      }

      const touch = e.changedTouches[0];
      const dx = touch.clientX - touchRef.current.x;
      const dy = Math.abs(touch.clientY - touchRef.current.y);
      touchRef.current = null;

      const angle = Math.atan2(dy, dx) * (180 / Math.PI);
      if (dx >= SWIPE_THRESHOLD && angle <= ANGLE_LIMIT) {
        goBack();
      }
    }

    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, [canGoBack, goBack]);
}
